import React from "react";
import { FWSection } from "../../../../design-system/fw";
import AncillaryRow from "./AncillaryRow";

/** שירותים — רשימה פשוטה, בלי כרטיס לכל פריט */
export default function ExtrasCard({ rows, currency }) {
  if (!rows || rows.length === 0) return null;

  return (
    <FWSection title="שירותים" lead="כבודה, טרולי ותוספות לפי הבחירה בהזמנה">
      <ul className="hr-fp-services-list">
        {rows.map((r) => (
          <li key={r.key} className="hr-fp-services-list__item">
            <AncillaryRow
              category={r.category}
              titleHe={r.titleHe}
              description={r.description}
              assignee={r.assignee}
              fare={r.fare}
              currency={currency}
            />
          </li>
        ))}
      </ul>
    </FWSection>
  );
}
